import React from 'react';
import { TbAlertCircle, TbUser } from 'react-icons/tb';
import { useLocation } from 'react-router-dom';

import LogoPrimary from '@/assets/images/black-for-restaurants.webp';

import { Typography } from '@/components/atoms/Typography';
import { SubscriptionRestoForm } from '@/components/organisms/SubscriptionRestoForm';

enum infoType {
  checkEmail = 'checkEmail',
  error = 'error',
  alreadyExists = 'alreadyExists'
}

export const SubscriptionRestoPage = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const emailInSlug = params.get('email');
  const restaurantName = params.get('restaurant');
  const info = params.get('info');

  const renderInfo = () => {
    switch (info) {
      case infoType.checkEmail:
        return (
          <div className="flex items-center gap-1 justify-center flex-col">
            <div className="flex items-center gap-2 justify-center">
              <TbAlertCircle size={24} className="text-red-500" />
              <Typography variant="h3">Consultez vos emails pour valider l'ajout de votre restaurant</Typography>
            </div>
            <Typography variant="h3">
              Un e-mail pour ajouter <strong>{restaurantName}</strong> vous à été envoyé sur <strong>{emailInSlug}</strong>
            </Typography>
          </div>
        );

      case infoType.error:
        return (
          <div className="flex items-center gap-2 justify-center flex-col">
            <TbAlertCircle size={32} className="text-red-400" />
            <Typography variant="h3">Une erreur vient de se produire.</Typography>
          </div>
        );

      case infoType.alreadyExists:
        return (
          <div className="flex items-center gap-1 justify-center flex-col">
            <div className="flex items-center gap-2 justify-center">
              <TbAlertCircle size={24} className="text-red-500" />
              <Typography variant="h3" align="center">
                Le restaurant existe déjà.
              </Typography>
            </div>
            <Typography variant="h3" align="center">
              S'il vous appartient, accéder à votre espace pour le revendiquer.
            </Typography>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-default-restaurant bg-cover min-h-screen h-full w-full mx-auto">
      <div className=" mx-auto bg-primary md:p-6 p-4 rounded-b-3xl items-center justify-center flex flex-col gap-3 md:grid grid-cols-3 ">
        <img height={50} width={50} src={LogoPrimary} alt="logo of mrh" className="w-40 object-cover" />
        <Typography color="white" variant="h1" weight="semibold" align="center">
          Ajout de mon restaurant
        </Typography>
      </div>

      {renderInfo() ? (
        <section className="flex flex-col md:flex-row gap-5 md:gap-20 mt-10 justify-center">
          <section className="bg-white w-fit space-y-4 md:border rounded-xl md:p-10 p-5 text-center">{renderInfo()}</section>
        </section>
      ) : (
        <section className="bg-white max-w-6xl mx-auto md:border rounded-xl md:p-10 p-5 space-y-10 mt-12">
          <div className="flex justify-center">
            <a href="/login" className="hover:underline p-2 border rounded-full border-gray-400 text-gray-600 items-center w-fit px-4 flex gap-2">
              <TbUser size={24} className="text-gray-600" />
              Je possède déjà un compte MonRestoHalal For Restaurants
            </a>
          </div>
          <SubscriptionRestoForm />
        </section>
      )}
    </div>
  );
};
